import {
  ActivityIndicator,
  Dimensions,
  Modal,
  PixelRatio,
  Platform,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import Colours from "../../utils/Colours";
import AppTextInput from "../../utils/ColourThemes/AppTextInput";
import { useState } from "react";
import TopHeaderComponent from "../aTopHeader/TopHeaderComponent";
import BusinessBankDetails from "./BusinessBankDetails";
import * as ImageManipulator from "expo-image-manipulator";
import * as FileSystem from "expo-file-system/legacy";
import * as ImagePicker from "expo-image-picker";
import { Image } from "expo-image";
import ErrorAlertComp from "../../alertComp/ErrorAlertComp";
import { SafeAreaView } from "react-native-safe-area-context";
import { useNavigation } from "@react-navigation/native";

const { width, height } = Dimensions.get("window");
const dpr = Math.round(PixelRatio.get() || 1);
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;
const VAL_NAME = "dxfdmlk0f";
const MAX_RETRIEZ = 20;

// Function to adjust font size
const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;

  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const MAX_IMAGE_SIZE_MB = 1;
const MAX_IMAGE_SIZE_BYTES = MAX_IMAGE_SIZE_MB * 1024 * 1024;

const Create_a_Brand = () => {
  const [isBrandNameFormClicked, setIsBrandNameFormClicked] = useState(false);
  const [isBrandImageFormClicked, setIsBrandImageFormClicked] = useState(false);
  const [isIndustryFormClicked, setIsIndustryFormClicked] = useState(false);
  const [isLocationFormClicked, setIsLocationFormClicked] = useState(false);
  const [isCreatedClicked, setIsCreatedClicked] = useState(false);
  const [showCreateBankDetails, setShowCreateBankDetails] = useState(false);
  const [brandBio, setBrandBio] = useState(null);
  const [brandName, setBrandName] = useState("");
  const [brandAddress, setBrandAddress] = useState("");
  const [image, setImage] = useState(null);
  const [selectedTags, setSelectedTags] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [isErrorCompVisible, setIsErrorCompVisible] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [isLoading3, setIsLoading3] = useState(false);

  const categories = ["Nightlife Venue", "Promoter"];

  const navigation = useNavigation();

  const handleTagSelection = (tag) => {
    if (selectedTags === tag) {
      setSelectedTags(null);
      ////console.log('TAGS', tag)
    } else {
      setSelectedTags(tag);
      ////console.log('TAGS2', tag)
    }
  };

  const formValidation = () => {
    if (brandName === "") {
      setIsBrandNameFormClicked(true);
    } else if (image === null) {
      setErrorMessage("Please select an image");
      setIsErrorCompVisible(true);
    } else if (selectedTags === null) {
      setErrorMessage("Please select category");
      setIsErrorCompVisible(true);
    } else if (brandAddress === "") {
      setIsLocationFormClicked(true);
    } else {
      const brandBioObj = { brandName, brandAddress, selectedTags, image };
      setBrandBio(brandBioObj);
      //console.log("All Good");
      //console.log("name", brandName);
      //console.log("Address", brandAddress);
      //console.log("category", selectedTags);
      //console.log("image", image);
      setIsCreatedClicked(true);

      setTimeout(() => {
        setShowCreateBankDetails(true);
      }, 50);
    }
  };

  const handleEnterBrandName = (text) => {
    setBrandName(text);
  };

  const handleEnterAddress = (text) => {
    setBrandAddress(text);
  };

  // const prepareImageForUpload = async (file) => {
  //   if (file.size <= MAX_IMAGE_SIZE_BYTES) return file;

  //   try {
  //     const MAX_WIDTH = 1200;

  //     // Decode + downscale in one step — avoids ever holding a full-res bitmap in memory
  //     const bitmap = await createImageBitmap(file, {
  //       resizeWidth: file.size > 20 * 1024 * 1024 ? MAX_WIDTH : undefined,
  //       resizeQuality: "medium",
  //     });

  //     const scale = Math.min(1, MAX_WIDTH / bitmap.width);
  //     const width = Math.round(bitmap.width * scale);
  //     const height = Math.round(bitmap.height * scale);

  //     const canvas = document.createElement("canvas");
  //     canvas.width = width;
  //     canvas.height = height;
  //     const ctx = canvas.getContext("2d");
  //     ctx.drawImage(bitmap, 0, 0, width, height);
  //     bitmap.close(); // release decoded memory immediately

  //     let quality = 0.9;
  //     while (quality > 0.1) {
  //       const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/jpeg", quality));
  //       if (!blob) break;
  //       if (blob.size <= MAX_IMAGE_SIZE_BYTES || quality <= 0.2) {
  //         return new File([blob], file.name, {
  //           type: "image/jpeg",
  //           lastModified: Date.now(),
  //         });
  //       }
  //       quality -= 0.1;
  //     }
  //     return file; // fallback
  //   } catch (err) {
  //     console.error("Compression failed:", err);
  //     return file; // fallback to original rather than hanging forever
  //   }
  // };
  // const pickImageFromPhone = async () => {
  //   try {
  //     setIsLoading(true);

  //     let result = await ImagePicker.launchImageLibraryAsync({
  //       mediaTypes: ["images"],
  //       allowsEditing: true,
  //       aspect: [4, 4],
  //       quality: 1,
  //     });

  //     // 🌟 FIX: Cleanly exit early if the user canceled so isLoading breaks out immediately
  //     if (result.canceled) return;

  //     const currentAsset = result.assets[0];
  //     const imageUri = currentAsset.uri;
  //     let fileSizeInMB = 0;
  //     let rawFileBinary = null; // Store the binary reference for web-safe compression pipelines

  //     // 🌟 CROSS-PLATFORM FILE SIZE & BINARY EXTRACTION CHECK (PWA Safe)
  //     if (Platform.OS === "web") {
  //       if (currentAsset.file) {
  //         rawFileBinary = currentAsset.file;
  //         fileSizeInMB = rawFileBinary.size / (1024 * 1024);
  //       } else {
  //         // Fallback web blob fetch evaluation if the file handle isn't attached directly
  //         const response = await fetch(imageUri);
  //         rawFileBinary = await response.blob();
  //         fileSizeInMB = rawFileBinary.size / (1024 * 1024);
  //       }
  //     } else {
  //       // Native Device file size check using expo-file-system
  //       const fileInfo = await FileSystem.getInfoAsync(imageUri);
  //       fileSizeInMB = fileInfo.size / (1024 * 1024);
  //     }

  //     // Guardrail size boundary validation check
  //     if (fileSizeInMB > 65) {
  //       setErrorMessage(
  //         `Image too large: The selected image is ${fileSizeInMB.toFixed(
  //           2,
  //         )} MB. Please choose a smaller one.`,
  //       );
  //       setIsErrorCompVisible(true);
  //       return; // stop further action
  //     }
  //     console.log("right herrxxxer");

  //     // 🌟 SMART COMPRESSION HANDOFF
  //     // If on web, send the raw File/Blob binary to your preparation loop. Otherwise, fall back to the string URI.
  //     const fileToProcess = Platform.OS === "web" ? rawFileBinary : imageUri;
  //     const processedImageResult = await prepareImageForUpload(fileToProcess);
  //     console.log("right herrer");
  //     //console.log("processedImageResult", processedImageResult);

  //     //console.log("processedImageResult Target ready:", processedImageResult);

  //     // 🌟 STATE RETENTION STRATEGY
  //     // If 'prepareImageForUpload' returns a web File object on browser execution,
  //     // convert it to a dynamic preview string URL for your UI layout, but make sure
  //     // to keep a reference to the raw binary file for your multi-part form submissions!
  //     if (Platform.OS === "web" && typeof processedImageResult !== "string") {
  //       const previewUrl = URL.createObjectURL(processedImageResult);
  //       //console.log("previewUrl", previewUrl);

  //       // Example approach if you split preview string and upload binary:
  //       setImage(previewUrl);
  //       // setRawUploadFile(processedImageResult); // Keep this state for your ultimate form submission payload!
  //     } else {
  //       // Native device path string fallback
  //       setImage(processedImageResult);
  //     }
  //   } catch (error) {
  //     console.error("Error executing dynamic PWA image picking sequence:", error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const withTimeout = (promise, ms, label) =>
    Promise.race([
      promise,
      new Promise((_, reject) =>
        setTimeout(() => reject(new Error(`${label} timed out after ${ms}ms`)), ms),
      ),
    ]);

  const prepareImageForUpload = async (imageUri, knownSize = null) => {
    try {
      let sizeInBytes = knownSize;

      if (sizeInBytes == null) {
        if (Platform.OS === "web") {
          // Can't reliably use FileSystem on web — skip straight to compression check
          sizeInBytes = null;
        } else {
          const fileInfo = await FileSystem.getInfoAsync(imageUri);
          sizeInBytes = fileInfo.size ?? null;
        }
      }

      if (sizeInBytes != null && sizeInBytes <= MAX_IMAGE_SIZE_BYTES) {
        return imageUri; // already small enough
      }

      let compressRatio = 0.9;
      let compressed = null;

      while (compressRatio > 0.1) {
        compressed = await withTimeout(
          ImageManipulator.manipulateAsync(imageUri, [], {
            compress: compressRatio,
            format: ImageManipulator.SaveFormat.JPEG,
          }),
          8000,
          "ImageManipulator",
        );

        let compressedSize;
        if (Platform.OS === "web") {
          const resp = await fetch(compressed.uri);
          const blob = await resp.blob();
          compressedSize = blob.size;
        } else {
          const compressedInfo = await FileSystem.getInfoAsync(compressed.uri);
          compressedSize = compressedInfo.size;
        }

        if (compressedSize && compressedSize <= MAX_IMAGE_SIZE_BYTES) {
          return compressed.uri;
        }

        compressRatio -= 0.1;
      }

      console.warn("Could not get image under 1MB. Returning best attempt.");
      return compressed ? compressed.uri : imageUri;
    } catch (error) {
      console.error("Image compression failed or timed out:", error);
      return imageUri; // fallback to original — never hangs
    }
  };

  const pickImageFromPhone = async () => {
    try {
      setIsLoading(true);

      let result = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ["images"],
        allowsEditing: true,
        aspect: [4, 4],
        quality: 1,
      });

      if (result.canceled) return;

      const currentAsset = result.assets[0];
      const imageUri = currentAsset.uri;
      let fileSizeInMB = 0;

      if (Platform.OS === "web") {
        if (currentAsset.file) {
          fileSizeInMB = currentAsset.file.size / (1024 * 1024);
        } else {
          const response = await fetch(imageUri);
          const blob = await response.blob();
          fileSizeInMB = blob.size / (1024 * 1024);
        }
      } else {
        const fileInfo = await FileSystem.getInfoAsync(imageUri);
        fileSizeInMB = fileInfo.size / (1024 * 1024);
      }

      if (fileSizeInMB > 65) {
        setErrorMessage(
          `Image too large: The selected image is ${fileSizeInMB.toFixed(2)} MB. Please choose a smaller one.`,
        );
        setIsErrorCompVisible(true);
        return;
      }

      const knownSizeBytes = fileSizeInMB * 1024 * 1024;
      const processedUri = await prepareImageForUpload(imageUri, knownSizeBytes);

      setImage(processedUri); // always a string URI now — no more branching
    } catch (error) {
      console.error("Error executing image picking sequence:", error);
      setErrorMessage("Something went wrong processing that image. Please try again.");
      setIsErrorCompVisible(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCreatedClicked = () => {
    formValidation();
  };
  return (
    <SafeAreaView style={{ backgroundColor: "white" }}>
      <TopHeaderComponent headerText={"Create a brand"} hideScreen={() => navigation.goBack()} />
      <ScrollView
        style={styles.componentStyle}
        contentContainerStyle={{ flexGrow: 1, paddingBottom: 100 }}
        showsVerticalScrollIndicator={false}
      >
        <View style={styles.formaContainer}>
          <Text
            style={{
              fontSize: dynamicFontSize(15),
              color: Colours.DARKGRAY,
              fontFamily: "Sen-Regular",
            }}
          >
            Brand/Business name
          </Text>
          <AppTextInput
            style={[styles.formstyle, isBrandNameFormClicked && styles.focusedBorder]}
            placeholder="Brand name"
            onFocus={() => setIsBrandNameFormClicked(true)}
            onBlur={() => setIsBrandNameFormClicked(false)}
            onChangeText={(text) => {
              //console.log("TextWrite", text);
              handleEnterBrandName(text);
            }}
          />

          <Text
            style={{
              fontSize: dynamicFontSize(15),
              color: Colours.DARKGRAY,
              fontFamily: "Sen-Regular",
            }}
          >
            Brand image or Logo
          </Text>
          {/* <AppTextInput
          style={[styles.formstyle, isBrandImageFormClicked && styles.focusedBorder]}
          placeholder="Brand name"
          onFocus={() => setIsBrandImageFormClicked(true)}
          onBlur={() => setIsBrandNameFormClicked(false)}
          onChangeText={(text) => {
            //console.log("TextWrite", text);
          }}
        /> */}
          {isLoading ? (
            <ActivityIndicator size="large" color={Colours.PRIMARY} />
          ) : (
            <TouchableOpacity
              style={[styles.photoViewStyle, isBrandImageFormClicked && styles.focusedBorder]}
              onPress={() => {
                pickImageFromPhone();
              }}
              onPressIn={() => setIsBrandImageFormClicked(true)}
              onPressOut={() => setIsBrandImageFormClicked(false)}
            >
              <Text style={styles.photosTxt}>Image:</Text>
              {image ? (
                <Image
                  source={{ uri: image }}
                  style={[styles.imageviewStyle2, { backgroundColor: "#d6d4d4ff" }]}
                  contentFit="cover"
                  cachePolicy="disk"
                  // onError={handleImageError}
                />
              ) : (
                <Image
                  style={styles.imageviewStyle2}
                  source={require("../../../assets/imagePlaceholder.jpg")}
                />
              )}
            </TouchableOpacity>
          )}
          <Text
            style={{
              fontSize: dynamicFontSize(15),
              color: Colours.DARKGRAY,
              fontFamily: "Sen-Regular",
            }}
          >
            Category
          </Text>
          {/* 
        <Text
          style={{
            fontSize: dynamicFontSize(15),
            color: Colours.DARKGRAY,
            fontFamily: "Sen-Regular",
          }}
        >
          Industry
        </Text>
        <AppTextInput
          style={[styles.formstyle, isIndustryFormClicked && styles.focusedBorder]}
          placeholder="Industry"
          onFocus={() => setIsIndustryFormClicked(true)}
          onBlur={() => setIsIndustryFormClicked(false)}
          onChangeText={(text) => {
            //console.log("TextWrite", text);
          }}
        /> */}

          <View style={styles.tagsViewStyle}>
            {categories.map((tag) => (
              <TouchableOpacity
                key={tag}
                style={{
                  backgroundColor: selectedTags === tag ? Colours.PRIMARY : "white",
                  borderRadius: dynamicSize(20),
                  padding: dynamicSpacing(7),
                  margin: dynamicSpacing(3),
                }}
                onPress={() => handleTagSelection(tag)}
              >
                <Text
                  style={{
                    fontFamily: "Sen-Regular",
                    color: selectedTags === tag ? "white" : Colours.DARKGRAY,
                  }}
                >
                  {tag}
                </Text>
              </TouchableOpacity>
            ))}
          </View>

          <Text
            style={{
              fontSize: dynamicFontSize(15),
              color: Colours.DARKGRAY,
              fontFamily: "Sen-Regular",
            }}
          >
            Address Location
          </Text>
          <AppTextInput
            style={[styles.formstyle, isLocationFormClicked && styles.focusedBorder]}
            placeholder="Address"
            onFocus={() => setIsLocationFormClicked(true)}
            onBlur={() => setIsLocationFormClicked(false)}
            onChangeText={(text) => {
              //console.log("TextWrite", text);
              handleEnterAddress(text);
            }}
          />

          <TouchableOpacity
            style={[
              styles.greyButton2,

              {
                backgroundColor: isCreatedClicked ? Colours.PRIMARY : Colours.LIGHTEST,
              },
            ]}
            onPress={handleCreatedClicked}
            disabled={isLoading3}
          >
            {isLoading3 ? (
              <ActivityIndicator size="small" color="white" />
            ) : (
              <Text
                style={[styles.createTxt, { color: isCreatedClicked ? "white" : Colours.DARKGRAY }]}
              >
                Proceed
              </Text>
            )}
          </TouchableOpacity>
        </View>
        <Modal
          animationType="fade"
          visible={showCreateBankDetails}
          onRequestClose={() => setShowCreateBankDetails(false)}
        >
          <TopHeaderComponent
            headerText={"Bank Details"}
            hideScreen={() => setShowCreateBankDetails(false)}
          />

          <BusinessBankDetails
            brandBio={brandBio}
            hideModal={() => {
              // hideModal();
              setShowCreateBankDetails(false);
              navigation.navigate("Home");
            }}
          />
        </Modal>
        <Modal
          visible={isErrorCompVisible}
          transparent={true}
          animationType="fade"
          onRequestClose={() => setIsErrorCompVisible(false)}
        >
          <ErrorAlertComp message={errorMessage} onClose={() => setIsErrorCompVisible(false)} />
        </Modal>
      </ScrollView>
    </SafeAreaView>
  );
};

export default Create_a_Brand;

const styles = StyleSheet.create({
  componentStyle: {
    backgroundColor: Colours.LIGHTEST,
    display: "flex",
    // padding: dynamicSpacing(15),
    height: "100%",
  },
  formaContainer: {
    display: "flex",
    padding: dynamicSpacing(15),
    margin: dynamicSpacing(15),
    backgroundColor: "white",
    borderRadius: dynamicSize(15),
  },

  formstyle: {
    display: "flex",
    padding: dynamicSpacing(15),
    marginVertical: dynamicSpacing(10),
    borderRadius: dynamicSize(10),
    fontFamily: "Sen-Regular",
    borderColor: Colours.LIGHTGRAY,
    borderWidth: dynamicSize(2),
  },
  focusedBorder: {
    borderColor: Colours.PRIMARY,
  },
  photoViewStyle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    // height: dynamicSize(60),
    // width: "100%",
    padding: dynamicSpacing(10),
    marginVertical: dynamicSpacing(10),
    borderRadius: dynamicSize(10),
    borderWidth: dynamicSize(2),
    borderColor: Colours.LIGHTGRAY,
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(15),
    backgroundColor: Colours.LIGHTEST,
  },
  tagsViewStyle: {
    flex: 1,
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    marginTop: dynamicSpacing(10),
    marginBottom: dynamicSpacing(5),
    padding: dynamicSpacing(10),
    borderWidth: dynamicSize(3),
    borderColor: Colours.LIGHTGRAY,
    borderRadius: dynamicSize(15),
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(17),
    backgroundColor: Colours.LIGHTGRAY,
  },
  photosTxt: {
    marginRight: dynamicSpacing(100),
    color: Colours.DARKLIGHTGRAY,
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Regular",
  },
  imageviewStyle2: {
    width: dynamicSize(35),
    height: dynamicSize(30),
    borderRadius: dynamicSize(6),
  },
  greyButton2: {
    display: "flex",
    borderRadius: dynamicSize(10),
    justifyContent: "center",
    marginTop: dynamicSpacing(20),
    alignItems: "center",
    height: dynamicSize(55),
    width: "100%",
    backgroundColor: Colours.LIGHTEST,
  },
  createTxt: {
    fontSize: dynamicFontSize(15),
    color: "white",
    fontFamily: "Sen-Bold",
  },
});
